module.exports = __webpack_public_path__ + "img/message-system@3x.a3986bc5.png";